import { useMedia } from "react-use";
import { storboltLogo } from "images";

const Logo = () => {
  const mode = useMedia("(prefers-color-scheme: dark)");
  return (
    <div>
      <img
        src={
          mode ? storboltLogo : storboltLogo // TODO: change to logo-white for dark mode
        }
        alt=""
        width={300}
        height={300}
        className="w-12 h-12"
      />
    </div>
  );
};

export default Logo;
